export default "__VITE_ASSET__CxZDiiEO__"